import { Core } from "@faire/design-tokens";
import { trackSeoExplorePageCtaClick } from "@faire/web-api/events/seo/click/explorePageCta";
import { Button } from "@faire/web/slate/Button";
import { Arrow } from "@faire/web/slate/icons/Arrow";
import { Spacer } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { prependLocaleToUrl } from "@faire/web/ui/routing/util";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import { discoverSearch } from "@faire/retailer/lib/seoPaths";
import { useRetailerRoutingContext } from "@faire/retailer/RetailerRoutingContextProvider";
import { useExplorePageSearchTerm } from "@faire/retailer/views/explore-page/__internal__/useExplorePageSearchTerm";

const ExplorePageCTABase: React.FC = () => {
  const { productSearchString } = useExplorePageSearchTerm();
  const routingContext = useRetailerRoutingContext();
  return (
    <StyledCTAWrapper>
      <StyledButton
        variant="secondary"
        linkTo={prependLocaleToUrl(
          discoverSearch(productSearchString),
          routingContext
        )}
        onClick={() => {
          trackSeoExplorePageCtaClick();
        }}
      >
        <StrictLocalMsg
          defaultMessage="Shop All"
          description={{
            text: "Shop All button on explore page",
          }}
        />
        <Spacer width="1x" />
        <Arrow direction="right" />
      </StyledButton>
      <Spacer width="2x" />
      <Typography color={Core.text.subdued} align="center">
        <StrictLocalMsg
          defaultMessage="Buy now, pay 60 days later—interest free."
          description={{
            text: "subheading next to Shop All button on the explore page",
          }}
        />
      </Typography>
    </StyledCTAWrapper>
  );
};

export const ExplorePageCTA = observer(ExplorePageCTABase);

const StyledCTAWrapper = styled.div`
  display: flex;
  align-items: center;

  ${responsiveMediaQueries.mobile} {
    flex-direction: column;
  }

  padding: 16px 0;
`;

const StyledButton = styled(Button)`
  ${responsiveMediaQueries.desktopAndAbove} {
    width: fit-content;
    min-width: 341px;
  }

  ${responsiveMediaQueries.tablet} {
    width: fit-content;
    min-width: 235px;
  }

  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
